export const menuItems = [
  {
    id: 1,
    label: "List of Tests",
    link: "/search",
    acl: ["admin", "manager", "user"],
    icon: "IcTests",
  },
  {
    id: 2,
    label: "Apps",
    link: "/apps",
    icon: "IcApps",
    acl: ["admin", "manager"],
  },
  {
    id: 3,
    label: "Permissions",
    link: "/permissions",
    icon: "IcPermissions",
    acl: ["admin"],
  },
];
